
import React from 'react';

import {
    Card,
    Typography
} from '@mui/material';

import { grey } from '@mui/material/colors';

import { CommonIcons, icons } from './CommonIcons'

export default function CommonRestricted() {

    return (
        <Card
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                // backgroundColor: '#fff',
                // borderRadius: 1,
                p: 2,
                minHeight: 500
            }}
        >
            <CommonIcons
                name={icons.disabled}
                sx={{
                    width: 120,
                    height: 120,
                    color: grey[400]
                }}
            />
            <Typography
                sx={{
                    fontSize: 18,
                    fontWeight: '700'
                }}
            >
                Unauthorized Access
            </Typography>
            <Typography
                sx={{
                    fontSize: 13
                }}
            >
                Please get contact with administrator for permission configurations
            </Typography>
        </Card>
    )
}

